import Home from "./Pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import News from "./Pages/News";
import OurServices from "./Pages/OurServices";
import About from "./Pages/About";
import BookNow from "./Pages/BookNow";
import Contact from "./Pages/Contact";
import Login from "./Pages/Login";
import Signup from "./Pages/Signup";
import TermsNCondition from "./Pages/TermsNCondition";
import Policy from "./Pages/Policy";
import BlogDetail from "./Pages/BlogDetail";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Profile from "./Pages/Profile";
import "bootstrap/dist/css/bootstrap.min.css";
import Gallery from "./Pages/Gallery";
import Refund from "./Pages/Refund";
import FAQ from "./Pages/FAQ";
import Pricing from "./Pages/Pricing";
import Wishlist from "./Pages/Wishlist";
import "./App.css";
import Offers from "./Pages/Offers";
import Blogs from "./Pages/Blogs";
import Success from "./Pages/Success.jsx";
import Failed from "./Pages/Failed.jsx";
import DirectBooking from "./Pages/DirectBooking.jsx";
import AddOnServices from "./Pages/AddOnServices.jsx";
import ServicesSuccess from "./Pages/ServicesSuccess.jsx";
import KeywordLandingDetail from "./Pages/KeywordLandingDetail.jsx";

function App() {
  return (
    <>
      <ToastContainer autoClose={1000} />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/BookingSuccess" element={<Success />} />
          <Route path="/ServiceBookingSuccess" element={<ServicesSuccess />} />
          <Route path="/BookingSuccess/:id" element={<Success />} />
          <Route path="/FailedBooking" element={<Failed />} />
          <Route path="/news" element={<News />} />
          <Route path="/services" element={<OurServices />} />
          <Route path="/about" element={<About />} />
          <Route path="/booknow" element={<BookNow />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/slot-detail/:theaterId/:timeSlotId/:slotId"
            element={<DirectBooking />}
          />
          <Route path="/signup" element={<Signup />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/addOnServices/:id" element={<AddOnServices />} />
          <Route path="/offer" element={<Offers />} />

          <Route path="/tnc" element={<TermsNCondition />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/:slug" element={<KeywordLandingDetail />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/waitlist" element={<Wishlist />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
